/**
 * Smilodox Secret Sale soft gate — access foundation.
 * Direct visit: CLOSED (no SECRET auto-fallback). Mapping + Shopify applicable===true required.
 */
(function () {
  "use strict";

  const BODY_LOCKED = "smilodox-secret-sale-is-locked";
  const BODY_UNLOCKED = "smilodox-secret-sale-is-unlocked";
  const BODY_DESIGN = "smilodox-secret-sale-design-mode";
  const MAX_NAME = 40;
  const RESOLVING_TIMEOUT_MS = 12000;
  const STORAGE_NS = "smilodox:secret-sale:";

  function sanitizeCode(raw) {
    return String(raw || "")
      .trim()
      .replace(/\s+/g, "")
      .toUpperCase()
      .slice(0, MAX_NAME);
  }

  function sanitizeName(raw, fallback) {
    let value = String(raw || "")
      .trim()
      .replace(/\s+/g, " ");
    if (!value) return fallback || "";
    if (value.length > MAX_NAME) value = value.slice(0, MAX_NAME);
    return value;
  }

  function parseIsoMs(value) {
    if (!value) return 0;
    const ms = Date.parse(String(value).trim());
    return Number.isFinite(ms) ? ms : 0;
  }

  function readCodeFromUrl() {
    try {
      const params = new URLSearchParams(window.location.search);
      return params.get("discount") || params.get("code") || params.get("discount_code") || "";
    } catch (e) {
      return "";
    }
  }

  function readCodeFromPath() {
    try {
      const match = (window.location.pathname || "").match(/\/discount\/([^/?#]+)/i);
      if (!match) return "";
      return decodeURIComponent(match[1] || "").trim();
    } catch (e) {
      return "";
    }
  }

  function readCodeFromReferrer() {
    try {
      if (!document.referrer) return "";
      const match = new URL(document.referrer).pathname.match(/\/discount\/([^/?#]+)/i);
      if (!match) return "";
      return decodeURIComponent(match[1] || "").trim();
    } catch (e) {
      return "";
    }
  }

  function readCodeFromDiscountCookie() {
    try {
      const parts = String(document.cookie || "").split(";");
      for (let i = 0; i < parts.length; i += 1) {
        const part = parts[i].trim();
        if (part.indexOf("discount_code=") === 0) {
          return decodeURIComponent(part.slice("discount_code=".length)).trim();
        }
      }
    } catch (e) {}
    return "";
  }

  function isDesignMode() {
    return !!(window.Shopify && Shopify.designMode);
  }

  function formatNextEntryLabel(prefix, suffix, nextAt) {
    try {
      const datePart = new Intl.DateTimeFormat("de-DE", {
        day: "numeric",
        month: "long",
        year: "numeric",
      }).format(nextAt);
      const timePart = new Intl.DateTimeFormat("de-DE", {
        hour: "2-digit",
        minute: "2-digit",
      }).format(nextAt);
      return (prefix || "Dein nächster Zugang ist am") + " " + datePart + " um " + timePart + " " + (suffix || "bereit.");
    } catch (e) {
      return (prefix || "Dein nächster Zugang ist am") + " " + nextAt.toLocaleString("de-DE") + " " + (suffix || "bereit.");
    }
  }

  function SmilodoxSecretSaleGate(root) {
    this.root = root;
    this.shell = root.querySelector("[data-sss-shell]");
    this.invite = root.querySelector("[data-sss-invite]");
    this.inactive = root.querySelector("[data-sss-inactive]");
    this.finished = root.querySelector("[data-sss-finished]");
    this.ended = root.querySelector("[data-sss-ended]");
    this.prestart = root.querySelector("[data-sss-prestart]");
    this.heading = root.querySelector("[data-sss-heading]");
    this.inviteHeadline = root.querySelector("[data-sss-invite-headline]");
    this.resolvingHeadline = root.querySelector("[data-sss-resolving-headline]");
    this.introEl = root.querySelector("[data-sss-intro]");
    this.statusEl = root.querySelector("[data-sss-status]");
    this.statusTextEl = root.querySelector("[data-sss-status-text]");
    this.fieldEl = root.querySelector("[data-sss-field]");
    this.passwordEl = root.querySelector("[data-sss-password]");
    this.toggleBtn = root.querySelector("[data-sss-password-toggle]");
    this.noteEl = root.querySelector("[data-sss-note]");
    this.enterBtn = root.querySelector("[data-sss-enter]");
    this.inactiveHeading = root.querySelector("[data-sss-inactive-heading]");
    this.inactiveBody = root.querySelector("[data-sss-inactive-body]");
    this.finishedHeading = root.querySelector("[data-sss-finished-heading]");
    this.nextEntryEl = root.querySelector("[data-sss-next-entry]");
    this.endedHeading = root.querySelector("[data-sss-ended-heading]");
    this.prestartHeading = root.querySelector("[data-sss-prestart-heading]");
    this.prestartBody = root.querySelector("[data-sss-prestart-body]");

    this.handle = root.getAttribute("data-collection-handle") || "secret-sale";
    this.campaignKey = root.getAttribute("data-campaign-key") || "secret-sale";
    this.minutes = parseInt(root.getAttribute("data-timer-minutes") || "25", 10) || 25;
    this.pauseEnabled = root.getAttribute("data-pause-enabled") === "true";
    this.pauseHours = parseInt(root.getAttribute("data-pause-hours") || "24", 10) || 24;
    this.campaignStartMs = parseIsoMs(root.getAttribute("data-campaign-start"));
    this.campaignEndMs = parseIsoMs(root.getAttribute("data-campaign-end"));
    this.probeVariantId = (root.getAttribute("data-probe-variant-id") || "").trim();
    this.channelHeadline = root.getAttribute("data-channel-headline") || "Dein exklusiver Secret Sale ist bereit";
    this.influencerHeadlineTemplate =
      root.getAttribute("data-influencer-headline") || "{{name}} hat dich zum Secret Sale eingeladen";
    this.resolvingLabel = root.getAttribute("data-resolving-label") || "Einladung wird geprüft …";
    this.enterLabel = root.getAttribute("data-enter-label") || "Einloggen";
    this.nextEntryPrefix = root.getAttribute("data-next-entry-prefix") || "Dein nächster Zugang ist am";
    this.nextEntrySuffix = root.getAttribute("data-next-entry-suffix") || "bereit.";
    this.protectedIds = (root.getAttribute("data-protected-section-ids") || "main")
      .split(",")
      .map(function (id) {
        return id.trim();
      })
      .filter(Boolean);

    this.codeMap = this.parseCodeMap();
    this.designMode = isDesignMode();
    this.editorUnlocked = root.getAttribute("data-editor-unlocked") === "true";
    this.editorFinished = root.getAttribute("data-editor-finished") === "true";
    this.editorInactive = root.getAttribute("data-editor-inactive") === "true";
    this.editorEnded = root.getAttribute("data-editor-ended") === "true";
    this.editorPrestart = root.getAttribute("data-editor-prestart") === "true";

    this.unlocked = false;
    this.sessionFinished = false;
    this.campaignEnded = false;
    this.campaignPrestart = false;
    this.resolvingTimedOut = false;
    this.resolvingTimeoutId = null;
    this.destroyed = false;
    this.validationInFlight = false;
    this.reconcileTimeoutIds = [];
    this.tickerId = null;
    this.currentAccess = null;
    this.ajaxCartCodes = [];
    this.cartEvidenceInFlight = null;

    this.onEnter = this.onEnter.bind(this);
    this.onTogglePassword = this.onTogglePassword.bind(this);
    this.onProbeState = this.onProbeState.bind(this);
    this.onStorage = this.onStorage.bind(this);
    this.onVisibility = this.onVisibility.bind(this);

    this.init();
  }

  SmilodoxSecretSaleGate.prototype.sessionKey = function () {
    return STORAGE_NS + "session:" + this.campaignKey;
  };

  SmilodoxSecretSaleGate.prototype.expiryKey = function () {
    return STORAGE_NS + "expires-at:" + this.campaignKey;
  };

  SmilodoxSecretSaleGate.prototype.nextEntryKey = function () {
    return STORAGE_NS + "next-entry-at:" + this.campaignKey;
  };

  SmilodoxSecretSaleGate.prototype.parseCodeMap = function () {
    const map = {};
    const self = this;

    function ingestObject(obj) {
      if (!obj || typeof obj !== "object" || Array.isArray(obj)) return;
      Object.keys(obj).forEach(function (rawKey) {
        const code = sanitizeCode(rawKey);
        if (!code) return;
        const item = obj[rawKey] || {};
        const type = item.type === "influencer" ? "influencer" : "channel";
        const percent = parseFloat(item.percent);
        map[code] = {
          code: code,
          active: item.active !== false,
          percent: Number.isFinite(percent) ? Math.min(100, Math.max(0, percent)) : 35,
          type: type,
          source: String(item.source || "").trim(),
          display_name: sanitizeName(item.display_name || item.name || "", ""),
        };
      });
    }

    function ingestArray(list) {
      if (!Array.isArray(list)) return;
      list.forEach(function (item) {
        if (!item) return;
        const code = sanitizeCode(item.code || item.discount_code || "");
        if (!code) return;
        ingestObject({ [code]: item });
      });
    }

    function parseNode(selector) {
      const node = self.root.querySelector(selector);
      if (!node) return null;
      try {
        return JSON.parse(node.textContent || "null");
      } catch (e) {
        return null;
      }
    }

    const setting = parseNode("[data-sss-code-map]");
    if (Array.isArray(setting)) ingestArray(setting);
    else ingestObject(setting);

    ingestArray(parseNode("[data-sss-code-blocks]"));

    return map;
  };

  SmilodoxSecretSaleGate.prototype.lookupCode = function (code) {
    const key = sanitizeCode(code);
    if (!key) return null;
    return this.codeMap[key] || null;
  };

  SmilodoxSecretSaleGate.prototype.isMappedActive = function (code) {
    const mapped = this.lookupCode(code);
    return Boolean(mapped && mapped.active !== false);
  };

  SmilodoxSecretSaleGate.prototype.buildInviteHeadline = function (mapped) {
    if (!mapped) return this.channelHeadline;
    if (mapped.type === "influencer" && mapped.display_name) {
      return this.influencerHeadlineTemplate
        .replace(/\{\{\s*name\s*\}\}/gi, mapped.display_name)
        .replace(/\{name\}/gi, mapped.display_name);
    }
    return this.channelHeadline;
  };

  SmilodoxSecretSaleGate.prototype.readTimestamp = function (key) {
    try {
      const value = parseInt(localStorage.getItem(key) || "", 10);
      return Number.isFinite(value) ? value : 0;
    } catch (e) {
      return 0;
    }
  };

  SmilodoxSecretSaleGate.prototype.writeTimestamp = function (key, value) {
    try {
      localStorage.setItem(key, String(value));
    } catch (e) {}
  };

  SmilodoxSecretSaleGate.prototype.clearTimestamp = function (key) {
    try {
      localStorage.removeItem(key);
    } catch (e) {}
  };

  SmilodoxSecretSaleGate.prototype.readSessionRecord = function () {
    try {
      const raw = localStorage.getItem(this.sessionKey());
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || !parsed.code || !parsed.sessionEnd) return null;
      return parsed;
    } catch (e) {
      return null;
    }
  };

  SmilodoxSecretSaleGate.prototype.writeSessionRecord = function (record) {
    try {
      localStorage.setItem(this.sessionKey(), JSON.stringify(record));
    } catch (e) {}
  };

  SmilodoxSecretSaleGate.prototype.clearSessionRecord = function () {
    try {
      localStorage.removeItem(this.sessionKey());
    } catch (e) {}
  };

  SmilodoxSecretSaleGate.prototype.now = function () {
    return Date.now();
  };

  SmilodoxSecretSaleGate.prototype.isBeforeCampaignStart = function () {
    return Boolean(this.campaignStartMs && this.now() < this.campaignStartMs);
  };

  SmilodoxSecretSaleGate.prototype.isAfterCampaignEnd = function () {
    return Boolean(this.campaignEndMs && this.now() > this.campaignEndMs);
  };

  SmilodoxSecretSaleGate.prototype.isOutsideCampaignWindow = function () {
    return this.isBeforeCampaignStart() || this.isAfterCampaignEnd();
  };

  SmilodoxSecretSaleGate.prototype.computeSessionEnd = function (unlockAt) {
    const capped = unlockAt + this.minutes * 60 * 1000;
    if (this.campaignEndMs) return Math.min(capped, this.campaignEndMs);
    return capped;
  };

  SmilodoxSecretSaleGate.prototype.readLiquidCartCodes = function () {
    const codes = [];
    try {
      const node = this.root.querySelector("[data-sss-cart-codes]");
      if (!node) return codes;
      const parsed = JSON.parse(node.textContent || "[]");
      if (!Array.isArray(parsed)) return codes;
      for (let i = 0; i < parsed.length; i += 1) {
        const code = sanitizeCode(parsed[i]);
        if (code) codes.push(code);
      }
    } catch (e) {}
    return codes;
  };

  /**
   * Candidate for a new validation attempt.
   * Explicit entry evidence: path, query, referrer.
   * Cookie alone is never enough (stale-cookie risk). Corroboration sources:
   * - Liquid cart.discount_codes snapshot (often empty right after /discount/ redirect)
   * - Async cart.js snapshot stored on this instance after hydrateCartEvidence()
   * Stored sessionStorage candidate alone is never enough.
   */
  SmilodoxSecretSaleGate.prototype.getCandidateCode = function () {
    const fromPath = sanitizeCode(readCodeFromPath());
    if (fromPath) return fromPath;

    const fromUrl = sanitizeCode(readCodeFromUrl());
    if (fromUrl) return fromUrl;

    const fromReferrer = sanitizeCode(readCodeFromReferrer());
    if (fromReferrer) return fromReferrer;

    const fromCookie = sanitizeCode(readCodeFromDiscountCookie());
    if (!fromCookie) return "";

    const liquidCodes = this.readLiquidCartCodes();
    if (liquidCodes.indexOf(fromCookie) !== -1) return fromCookie;

    const ajaxCodes = this.ajaxCartCodes || [];
    if (ajaxCodes.indexOf(fromCookie) !== -1) return fromCookie;

    return "";
  };

  /** True when this navigation carries explicit campaign-entry evidence (not cookie alone). */
  SmilodoxSecretSaleGate.prototype.hasExplicitCampaignEntry = function () {
    return Boolean(
      sanitizeCode(readCodeFromPath()) ||
        sanitizeCode(readCodeFromUrl()) ||
        sanitizeCode(readCodeFromReferrer()),
    );
  };

  /**
   * After /discount/CODE?redirect=… Shopify often lands with discount_code cookie set
   * while Liquid cart.discount_codes is still empty. cart.js usually already lists the code
   * (often applicable:false until probe). Hydrate so cookie can be corroborated safely.
   */
  SmilodoxSecretSaleGate.prototype.hydrateCartEvidence = function () {
    const probe = window.SmilodoxSecretSaleProbe;
    if (!probe || !probe.fetchCart) return Promise.resolve();
    if (this.cartEvidenceInFlight) return this.cartEvidenceInFlight;

    const self = this;
    this.cartEvidenceInFlight = probe
      .fetchCart()
      .then(function (cart) {
        const codes = [];
        ((cart && cart.discount_codes) || []).forEach(function (entry) {
          const code = sanitizeCode(entry && entry.code);
          if (code) codes.push(code);
        });
        self.ajaxCartCodes = codes;
        self.cartEvidenceInFlight = null;
        return codes;
      })
      .catch(function () {
        self.cartEvidenceInFlight = null;
        return [];
      });

    return this.cartEvidenceInFlight;
  };

  SmilodoxSecretSaleGate.prototype.readValidation = function (code) {
    const probe = window.SmilodoxSecretSaleProbe;
    if (!probe || !probe.readValidationResult) return "";
    return probe.readValidationResult(code) || "";
  };

  SmilodoxSecretSaleGate.prototype.evaluateAccess = function () {
    if (this.isBeforeCampaignStart()) {
      return { state: "prestart", code: "", canEnter: false, mapped: null };
    }
    if (this.isAfterCampaignEnd()) {
      return { state: "ended", code: "", canEnter: false, mapped: null };
    }

    const nextAt = this.readTimestamp(this.nextEntryKey());
    if (nextAt && nextAt > this.now()) {
      return { state: "finished", code: "", canEnter: false, mapped: null, nextAt: nextAt };
    }

    const candidateEarly = this.getCandidateCode();
    const session = this.readSessionRecord();
    const expiry = this.readTimestamp(this.expiryKey()) || (session && session.sessionEnd) || 0;
    if (session && expiry && expiry > this.now() && this.isMappedActive(session.code)) {
      // Latest campaign entry wins — including invalid/unmapped codes.
      // Candidate is already restricted to explicit URL/referrer OR cookie+cart.js
      // corroboration (never cookie alone). After /discount/CODE redirects, Shopify
      // strips ?discount= from the landing URL, so cookie+cart evidence must count.
      if (candidateEarly && candidateEarly !== sanitizeCode(session.code)) {
        this.clearSessionRecord();
        this.clearTimestamp(this.expiryKey());
        const probe = window.SmilodoxSecretSaleProbe;
        if (probe && probe.clearProbeArtifacts) {
          probe.clearProbeArtifacts(session.code);
          probe.clearProbeArtifacts(candidateEarly);
        }
      } else {
        return {
          state: "unlocked",
          code: sanitizeCode(session.code),
          canEnter: true,
          mapped: this.lookupCode(session.code),
        };
      }
    }

    const candidate = candidateEarly;
    if (!candidate) {
      return { state: "closed", code: "", canEnter: false, mapped: null };
    }

    const mapped = this.lookupCode(candidate);
    if (!mapped || mapped.active === false) {
      return { state: "inactive", code: candidate, canEnter: false, mapped: null };
    }

    const validation = this.readValidation(candidate);
    if (validation === "rejected") {
      return { state: "inactive", code: candidate, canEnter: false, mapped: mapped };
    }

    if (validation === "activated") {
      this.resolvingTimedOut = false;
      return {
        state: "invite",
        code: candidate,
        canEnter: true,
        mapped: mapped,
      };
    }

    if (this.resolvingTimedOut) {
      return { state: "inactive", code: candidate, canEnter: false, mapped: mapped };
    }

    return {
      state: "resolving",
      code: candidate,
      canEnter: false,
      mapped: mapped,
    };
  };

  SmilodoxSecretSaleGate.prototype.setProtected = function (locked) {
    // CSS body classes drive visibility; keep for future hooks.
    void locked;
  };

  SmilodoxSecretSaleGate.prototype.setPanelMode = function (mode) {
    const modes = ["invite", "inactive", "finished", "ended", "prestart"];
    modes.forEach(
      function (name) {
        const el = this[name];
        if (!el) return;
        if (name === mode) el.removeAttribute("hidden");
        else el.setAttribute("hidden", "");
      }.bind(this),
    );
  };

  SmilodoxSecretSaleGate.prototype.setHeadingMode = function (mode) {
    if (!this.heading) return;
    this.heading.setAttribute("data-sss-heading-mode", mode === "resolving" ? "resolving" : "invite");
  };

  SmilodoxSecretSaleGate.prototype.setStatusVisible = function (visible) {
    if (!this.statusEl) return;
    if (visible) this.statusEl.removeAttribute("hidden");
    else this.statusEl.setAttribute("hidden", "");
  };

  SmilodoxSecretSaleGate.prototype.setInviteDetailsVisible = function (visible) {
    if (this.introEl) {
      if (visible) this.introEl.removeAttribute("hidden");
      else this.introEl.setAttribute("hidden", "");
    }
    if (this.fieldEl) {
      if (visible) this.fieldEl.removeAttribute("hidden");
      else this.fieldEl.setAttribute("hidden", "");
    }
    if (this.noteEl) {
      if (visible) this.noteEl.removeAttribute("hidden");
      else this.noteEl.setAttribute("hidden", "");
    }
  };

  SmilodoxSecretSaleGate.prototype.setLoginEnabled = function (enabled) {
    if (!this.enterBtn) return;
    this.enterBtn.textContent = this.enterLabel;
    if (enabled) {
      this.enterBtn.disabled = false;
      this.enterBtn.removeAttribute("aria-disabled");
      this.enterBtn.removeAttribute("hidden");
    } else {
      this.enterBtn.disabled = true;
      this.enterBtn.setAttribute("aria-disabled", "true");
      this.enterBtn.setAttribute("hidden", "");
    }
  };

  SmilodoxSecretSaleGate.prototype.setPasswordValue = function (code) {
    if (!this.passwordEl) return;
    const value = sanitizeCode(code) || "";
    this.passwordEl.value = value;
    this.passwordEl.setAttribute("value", value);
    // Reset mask when value changes so reveal never leaks across states.
    this.passwordEl.setAttribute("type", "password");
    if (this.toggleBtn) {
      this.toggleBtn.setAttribute("aria-pressed", "false");
      this.toggleBtn.setAttribute("aria-label", "Passwort anzeigen");
    }
  };

  SmilodoxSecretSaleGate.prototype.applyInvitePresentation = function (access) {
    access = access || { state: "invite", canEnter: false, mapped: null, code: "" };

    if (this.statusTextEl) this.statusTextEl.textContent = this.resolvingLabel;
    if (this.resolvingHeadline) this.resolvingHeadline.textContent = this.resolvingLabel;
    if (this.inviteHeadline && access.mapped) {
      this.inviteHeadline.textContent = this.buildInviteHeadline(access.mapped);
    } else if (this.inviteHeadline && !access.mapped) {
      this.inviteHeadline.textContent = this.channelHeadline;
    }

    // Contract: password / note / Einloggen only after mapped + activated.
    // While resolving: personalized/neutral invite headline + status only.
    if (access.state === "resolving") {
      if (access.mapped) this.setHeadingMode("invite");
      else this.setHeadingMode("resolving");
      this.setInviteDetailsVisible(false);
      this.setStatusVisible(true);
      this.setLoginEnabled(false);
      this.setPasswordValue("");
      return;
    }

    const canReveal = Boolean(access.state === "invite" && access.canEnter && access.code && access.mapped);
    this.setHeadingMode("invite");
    this.setInviteDetailsVisible(canReveal);
    this.setStatusVisible(false);
    if (canReveal) this.setPasswordValue(access.code);
    else this.setPasswordValue("");
    this.setLoginEnabled(canReveal);
  };

  SmilodoxSecretSaleGate.prototype.onTogglePassword = function (event) {
    if (event) event.preventDefault();
    if (!this.passwordEl || !this.toggleBtn) return;
    const show = this.passwordEl.getAttribute("type") === "password";
    this.passwordEl.setAttribute("type", show ? "text" : "password");
    this.toggleBtn.setAttribute("aria-pressed", show ? "true" : "false");
    this.toggleBtn.setAttribute("aria-label", show ? "Passwort verbergen" : "Passwort anzeigen");
  };

  SmilodoxSecretSaleGate.prototype.renderLockedShell = function () {
    document.body.classList.add(BODY_LOCKED);
    document.body.classList.remove(
      BODY_UNLOCKED,
      "smilodox-secret-sale-session-ready",
      "smilodox-secret-sale-grid-pending",
      "smilodox-secret-sale-grid-ready",
    );
    document.body.removeAttribute("data-ss-code");
    document.body.removeAttribute("data-ss-percent");
    document.body.removeAttribute("data-ss-expires-at");
    this.setProtected(true);
    if (this.shell) this.shell.removeAttribute("hidden");
  };

  SmilodoxSecretSaleGate.prototype.renderUnlocked = function () {
    // Emit only on locked → unlocked. Reconciliation re-confirms an existing session
    // many times and must not re-emit (infinite-scroll restart) or move scroll.
    var alreadyUnlocked = document.body.classList.contains(BODY_UNLOCKED);
    this.unlocked = true;
    this.sessionFinished = false;
    this.campaignEnded = false;
    this.campaignPrestart = false;
    document.body.classList.remove(BODY_LOCKED);
    document.body.classList.add(BODY_UNLOCKED);
    this.setProtected(false);
    if (this.shell) this.shell.setAttribute("hidden", "");
    this.markReady();
    if (alreadyUnlocked) return;
    try {
      if (window.SmilodoxSecretSaleSession && SmilodoxSecretSaleSession.emit) {
        SmilodoxSecretSaleSession.emit({ type: "unlocked" });
      }
    } catch (e) {}
  };

  SmilodoxSecretSaleGate.prototype.renderInvite = function (access) {
    this.unlocked = false;
    this.sessionFinished = false;
    this.campaignEnded = false;
    this.campaignPrestart = false;
    this.renderLockedShell();
    this.setPanelMode("invite");
    this.applyInvitePresentation(access || { state: "invite", canEnter: false, mapped: null });
    this.markReady();
  };

  SmilodoxSecretSaleGate.prototype.renderClosed = function () {
    this.unlocked = false;
    this.sessionFinished = false;
    this.campaignEnded = false;
    this.campaignPrestart = false;
    this.renderLockedShell();
    this.setPanelMode("inactive");
    if (this.inactiveHeading) {
      this.inactiveHeading.textContent =
        this.root.getAttribute("data-closed-heading") || "Secret Sale nur mit Einladung";
    }
    if (this.inactiveBody) {
      this.inactiveBody.textContent =
        this.root.getAttribute("data-closed-body") ||
        "Dieser Bereich ist nur über einen gültigen Secret-Sale-Link erreichbar. Schau gerne weiter im Shop vorbei.";
    }
    this.markReady();
  };

  SmilodoxSecretSaleGate.prototype.renderInactive = function () {
    this.unlocked = false;
    this.sessionFinished = false;
    this.campaignEnded = false;
    this.campaignPrestart = false;
    this.renderLockedShell();
    this.setPanelMode("inactive");
    if (this.inactiveHeading) {
      this.inactiveHeading.textContent =
        this.root.getAttribute("data-inactive-heading") || "Dein Secret Sale ist nicht mehr aktiv.";
    }
    if (this.inactiveBody) {
      this.inactiveBody.textContent =
        this.root.getAttribute("data-inactive-body") ||
        "Diese Einladung ist ungültig oder abgelaufen. Schau gerne weiter im Shop vorbei.";
    }
    this.markReady();
  };

  SmilodoxSecretSaleGate.prototype.renderFinished = function (nextAt) {
    this.unlocked = false;
    this.sessionFinished = true;
    this.campaignEnded = false;
    this.campaignPrestart = false;
    this.renderLockedShell();
    this.setPanelMode("finished");
    if (this.nextEntryEl) {
      if (nextAt && (!this.campaignEndMs || nextAt < this.campaignEndMs)) {
        this.nextEntryEl.textContent = formatNextEntryLabel(
          this.nextEntryPrefix,
          this.nextEntrySuffix,
          new Date(nextAt),
        );
        this.nextEntryEl.removeAttribute("hidden");
      } else {
        this.nextEntryEl.textContent = "";
        this.nextEntryEl.setAttribute("hidden", "");
      }
    }
    this.markReady();
  };

  SmilodoxSecretSaleGate.prototype.renderEnded = function () {
    this.unlocked = false;
    this.sessionFinished = false;
    this.campaignEnded = true;
    this.campaignPrestart = false;
    this.renderLockedShell();
    this.setPanelMode("ended");
    this.markReady();
  };

  SmilodoxSecretSaleGate.prototype.renderPrestart = function () {
    this.unlocked = false;
    this.sessionFinished = false;
    this.campaignEnded = false;
    this.campaignPrestart = true;
    this.renderLockedShell();
    this.setPanelMode("prestart");
    if (this.prestartHeading) {
      this.prestartHeading.textContent =
        this.root.getAttribute("data-prestart-heading") || "Der Secret Sale startet bald.";
    }
    if (this.prestartBody) {
      this.prestartBody.textContent =
        this.root.getAttribute("data-prestart-body") ||
        "Dein persönlicher Zugang ist noch nicht freigeschaltet. Schau gerne weiter im Shop vorbei und komm zum Start wieder.";
    }
    this.markReady();
  };

  SmilodoxSecretSaleGate.prototype.applyGateState = function (access) {
    this.currentAccess = access;

    if (access.state === "unlocked") {
      this.renderUnlocked();
      this.startTicker(access);
      return;
    }
    if (access.state === "prestart") {
      this.renderPrestart();
      return;
    }
    if (access.state === "ended") {
      this.renderEnded();
      return;
    }
    if (access.state === "finished") {
      this.renderFinished(access.nextAt);
      return;
    }
    if (access.state === "closed") {
      this.renderClosed();
      return;
    }
    if (access.state === "inactive") {
      this.renderInactive();
      return;
    }
    if (access.state === "resolving" || access.state === "invite") {
      this.renderInvite(access);
      if (access.state === "resolving") this.scheduleResolvingTimeout();
      return;
    }

    this.renderClosed();
  };

  SmilodoxSecretSaleGate.prototype.scheduleResolvingTimeout = function () {
    if (this.destroyed || this.resolvingTimeoutId) return;
    const self = this;
    this.resolvingTimeoutId = setTimeout(function () {
      self.resolvingTimeoutId = null;
      if (self.destroyed || self.unlocked || self.sessionFinished) return;
      const access = self.evaluateAccess();
      if (access.state !== "resolving") return;
      self.resolvingTimedOut = true;
      self.applyGateState(self.evaluateAccess());
    }, RESOLVING_TIMEOUT_MS);
    this.reconcileTimeoutIds.push(this.resolvingTimeoutId);
  };

  SmilodoxSecretSaleGate.prototype.clearResolvingTimeout = function () {
    if (!this.resolvingTimeoutId) return;
    clearTimeout(this.resolvingTimeoutId);
    this.resolvingTimeoutId = null;
  };

  SmilodoxSecretSaleGate.prototype.startSession = function (code) {
    const mapped = this.lookupCode(code);
    if (!mapped || mapped.active === false) {
      this.renderInactive();
      return;
    }

    const unlockAt = this.now();
    const sessionEnd = this.computeSessionEnd(unlockAt);
    if (this.campaignEndMs && sessionEnd <= unlockAt) {
      this.renderEnded();
      return;
    }

    this.clearTimestamp(this.nextEntryKey());
    this.writeTimestamp(this.expiryKey(), sessionEnd);
    this.writeSessionRecord({
      campaignKey: this.campaignKey,
      code: sanitizeCode(code),
      percent: mapped.percent,
      type: mapped.type,
      source: mapped.source,
      display_name: mapped.display_name || "",
      sessionEnd: sessionEnd,
      campaignEnd: this.campaignEndMs || null,
      lastCollectionHandle: this.handle,
      unlockedAt: unlockAt,
    });

    this.renderUnlocked();
    // Scroll only after the customer clicks Einloggen — not on collection reconciles.
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    } catch (e) {
      window.scrollTo(0, 0);
    }
    this.startTicker({ code: sanitizeCode(code) });
  };

  SmilodoxSecretSaleGate.prototype.expireSession = function (sessionEnd) {
    this.stopTicker();
    this.clearTimestamp(this.expiryKey());
    this.clearSessionRecord();
    try {
      if (window.SmilodoxSecretSaleSession && SmilodoxSecretSaleSession.emit) {
        SmilodoxSecretSaleSession.emit({ type: "expire" });
      }
    } catch (e) {}

    // Campaign truly over → ended. Otherwise finished-access (no false return promise
    // when the 24h pause would land after campaign end).
    if (this.campaignEndMs && this.now() >= this.campaignEndMs) {
      this.clearTimestamp(this.nextEntryKey());
      this.renderEnded();
      return;
    }

    if (this.pauseEnabled) {
      const pauseUntil = (sessionEnd || this.now()) + this.pauseHours * 60 * 60 * 1000;
      this.writeTimestamp(this.nextEntryKey(), pauseUntil);
      if (this.campaignEndMs && pauseUntil >= this.campaignEndMs) {
        // Access closed for this visitor; do not promise a return time or claim campaign ended.
        this.renderFinished(null);
        return;
      }
      this.renderFinished(pauseUntil);
      return;
    }

    this.applyGateState(this.evaluateAccess());
  };

  SmilodoxSecretSaleGate.prototype.startTicker = function () {
    const self = this;
    this.stopTicker();
    const tick = function () {
      const expiry = self.readTimestamp(self.expiryKey());
      if (!expiry) return;
      if (expiry <= self.now()) {
        self.expireSession(expiry);
      }
    };
    tick();
    this.tickerId = window.setInterval(tick, 1000);
  };

  SmilodoxSecretSaleGate.prototype.stopTicker = function () {
    if (!this.tickerId) return;
    clearInterval(this.tickerId);
    this.tickerId = null;
  };

  SmilodoxSecretSaleGate.prototype.onEnter = function (event) {
    if (event) event.preventDefault();
    if (this.unlocked || this.sessionFinished || this.campaignEnded || this.campaignPrestart) return;
    const access = this.evaluateAccess();
    if (!(access.state === "invite" && access.canEnter && access.code)) return;
    this.startSession(access.code);
  };

  SmilodoxSecretSaleGate.prototype.onProbeState = function (event) {
    if (this.destroyed) return;
    try {
      const validation = event && event.detail && event.detail.validation;
      if (validation === "activated" || validation === "rejected") {
        this.resolvingTimedOut = false;
        this.clearResolvingTimeout();
      }
    } catch (e) {}
    this.reconcile();
  };

  SmilodoxSecretSaleGate.prototype.onStorage = function (event) {
    if (!event || !event.key) return;
    if (String(event.key).indexOf(STORAGE_NS) !== 0) return;
    this.reconcile();
  };

  SmilodoxSecretSaleGate.prototype.onVisibility = function () {
    if (document.visibilityState === "hidden") return;
    this.reconcile();
  };

  SmilodoxSecretSaleGate.prototype.reconcile = function () {
    if (this.destroyed || this.designMode) return;
    const self = this;
    const cookie = sanitizeCode(readCodeFromDiscountCookie());
    const needsHydrate =
      cookie &&
      !this.getCandidateCode() &&
      !(this.ajaxCartCodes && this.ajaxCartCodes.indexOf(cookie) !== -1);

    const continueReconcile = function () {
      if (self.destroyed) return;
      const access = self.evaluateAccess();
      self.applyGateState(access);
      if (access.state === "resolving" && access.code) {
        self.ensureValidation(access.code);
      }
    };

    if (needsHydrate) {
      this.hydrateCartEvidence().then(continueReconcile);
      return;
    }

    continueReconcile();
  };

  SmilodoxSecretSaleGate.prototype.ensureValidation = function (code) {
    const probe = window.SmilodoxSecretSaleProbe;
    if (!probe || !probe.validateCode) return;
    if (this.validationInFlight) return;

    const normalized = sanitizeCode(code);
    if (!normalized || !this.isMappedActive(normalized)) return;

    const existing = this.readValidation(normalized);
    if (existing === "activated" || existing === "rejected") return;

    this.validationInFlight = true;
    const self = this;

    probe
      .validateCode(normalized, { variantId: this.probeVariantId })
      .then(function (result) {
        self.validationInFlight = false;
        if (result === "activated" || result === "rejected") {
          self.resolvingTimedOut = false;
          self.clearResolvingTimeout();
        }
        self.reconcile();
      })
      .catch(function () {
        self.validationInFlight = false;
        self.reconcile();
      });
  };

  SmilodoxSecretSaleGate.prototype.markReady = function () {
    if (this.root) this.root.setAttribute("data-sss-ready", "true");
  };

  SmilodoxSecretSaleGate.prototype.bind = function () {
    if (this.enterBtn) this.enterBtn.addEventListener("click", this.onEnter);
    if (this.toggleBtn) this.toggleBtn.addEventListener("click", this.onTogglePassword);
    window.addEventListener("storage", this.onStorage);
    document.addEventListener("visibilitychange", this.onVisibility);
    window.addEventListener("focus", this.onVisibility);
    const probe = window.SmilodoxSecretSaleProbe;
    if (probe && probe.EVENT_STATE) {
      window.addEventListener(probe.EVENT_STATE, this.onProbeState);
    }
  };

  SmilodoxSecretSaleGate.prototype.destroy = function () {
    this.destroyed = true;
    this.stopTicker();
    this.clearResolvingTimeout();
    this.reconcileTimeoutIds.forEach(function (id) {
      clearTimeout(id);
    });
    this.reconcileTimeoutIds = [];
    if (this.enterBtn) this.enterBtn.removeEventListener("click", this.onEnter);
    if (this.toggleBtn) this.toggleBtn.removeEventListener("click", this.onTogglePassword);
    window.removeEventListener("storage", this.onStorage);
    document.removeEventListener("visibilitychange", this.onVisibility);
    window.removeEventListener("focus", this.onVisibility);
    const probe = window.SmilodoxSecretSaleProbe;
    if (probe && probe.EVENT_STATE) {
      window.removeEventListener(probe.EVENT_STATE, this.onProbeState);
    }
    document.body.classList.remove(BODY_LOCKED, BODY_UNLOCKED, BODY_DESIGN);
  };

  SmilodoxSecretSaleGate.prototype.init = function () {
    const probe = window.SmilodoxSecretSaleProbe;
    if (probe && probe.configure) {
      probe.configure({ variantId: this.probeVariantId });
    }

    this.bind();

    // Respect first-paint unlock for an already-validated session (gender-tab navigations).
    // Re-locking here caused gate/grid flicker between Secret Sale collections.
    var alreadyUnlocked = document.body.classList.contains(BODY_UNLOCKED);
    if (alreadyUnlocked) {
      this.unlocked = true;
      if (this.shell) this.shell.setAttribute("hidden", "");
    } else {
      document.body.classList.add(BODY_LOCKED);
    }

    if (this.designMode) {
      document.body.classList.add(BODY_DESIGN);
      if (this.editorUnlocked) {
        this.renderUnlocked();
      } else if (this.editorPrestart) {
        this.renderPrestart();
      } else if (this.editorEnded) {
        this.renderEnded();
      } else if (this.editorFinished) {
        this.renderFinished(this.now() + this.pauseHours * 60 * 60 * 1000);
      } else if (this.editorInactive) {
        this.renderInactive();
      } else {
        this.renderClosed();
      }
      return;
    }

    // Lock first, then hydrate cart.js evidence (cookie after /discount/…), then reconcile.
    const self = this;
    this.hydrateCartEvidence().then(function () {
      if (self.destroyed) return;
      const access = self.evaluateAccess();
      self.applyGateState(access);
      if (access.state === "resolving" && access.code) {
        self.ensureValidation(access.code);
      }
    });

    // Reconcile while Shopify attaches discount after /discount/…
    [100, 300, 750, 1500, 3000, 6000].forEach(function (ms) {
      const id = setTimeout(function () {
        if (self.destroyed) return;
        self.reconcile();
      }, ms);
      self.reconcileTimeoutIds.push(id);
    });
  };

  function mount(root) {
    if (!root || root.__sssInstance) return;
    root.__sssInstance = new SmilodoxSecretSaleGate(root);
  }

  function unmount(root) {
    if (!root || !root.__sssInstance) return;
    root.__sssInstance.destroy();
    root.__sssInstance = null;
  }

  function initAll(scope) {
    (scope || document).querySelectorAll("[data-sss-root]").forEach(mount);
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (!event.target) return;
    const root = event.target.querySelector("[data-sss-root]") || event.target;
    if (root && root.matches && root.matches("[data-sss-root]")) {
      unmount(root);
      mount(root);
    }
  });

  document.addEventListener("shopify:section:unload", function (event) {
    if (!event.target) return;
    const root = event.target.querySelector("[data-sss-root]") || event.target;
    if (root && root.matches && root.matches("[data-sss-root]")) {
      unmount(root);
    }
  });

  if (document.readyState === "loading") {
    initAll(document);
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }
})();
